import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TodaysPaymentRow = ({ payment }) => (
    <Paper variant="outlined" sx={{ p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
            <Typography variant="body2" fontWeight="bold">{payment.customerName}</Typography>
            <Typography variant="caption" color="text.secondary">{payment.description}</Typography>
        </Box>
        <Typography color="success.main" fontWeight="bold">
            {(payment.amount || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}
        </Typography>
    </Paper>
);

export default TodaysPaymentRow;
